import MaskedInput from 'react-text-mask';

import '../assets/styles/FormInputButton.css';

export default function FormInputButton({
  label,
  value,
  onChange,
  onClick,
  buttonLabel = "Aplicar",
  disabled = false,
  mask = "text",
  float = false,
  placeholder = "",
  icon = "",
  hideButton = false,
}) {

  const createMask = () => {
    switch (mask) {
      case '99999-999':
        return [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/];
      default:
        return false;
    }
  };

  
  
  const maskPattern = createMask();

  return (
    <div className={`FormInputButton ${float ? "form-floating" : ""} ${icon ? "form-floating-icon" : ""}`}>
      <MaskedInput
        mask={maskPattern}
        value={value}
        onChange={onChange}
        className="form-control"
        placeholder={placeholder || label}
      />
      {icon && <img className="icon" src={icon} alt="icon" />}
      {float && label && <label className="float-label">{label}</label>}
      {!hideButton && (
        <button
          type="button"
          className="btn inputFormButton"
          onClick={onClick}
          disabled={disabled || !value || value.length < 2}
        >
          {buttonLabel}
        </button>
      )}
    </div>
  );
}
